
/* Linda Store Custom - Claude Theme Editor */
(function() {
  var path = window.location.pathname;

  /* ==============================
     1. PRE-VENDAS: "Em breve!" message
     ============================== */
  var emBreveCollections = ['pre-vendas'];
  var collMatch = path.match(/\/collections\/([^\/\?]+)/);
  if (collMatch && emBreveCollections.indexOf(collMatch[1]) !== -1) {
    function replaceEmptyMessage() {
      var emptyEl = document.querySelector('#usf_container .tt-empty-search');
      if (!emptyEl) return false;
      emptyEl.innerHTML = '<span class="tt-icon icon-g-84"></span>' +
        '<span><h2>Em breve!</h2>' +
        '<p>Estamos preparando novidades pra voc\u00ea. Fique de olho!</p></span>';
      return true;
    }
    if (!replaceEmptyMessage()) {
      var observer = new MutationObserver(function() {
        if (replaceEmptyMessage()) observer.disconnect();
      });
      var container = document.getElementById('usf_container');
      if (container) observer.observe(container, { childList: true, subtree: true });
      var retries = 0;
      var interval = setInterval(function() {
        if (replaceEmptyMessage() || ++retries > 20) clearInterval(interval);
      }, 500);
    }
  }

  /* ==============================
     2. HOMEPAGE: Add H1 (visually hidden for SEO)
     ============================== */
  if (path === '/' || path === '') {
    var h1 = document.createElement('h1');
    h1.textContent = 'Linda Store - Cal\u00e7ados Brasileiros no Jap\u00e3o';
    h1.style.cssText = 'position:absolute;width:1px;height:1px;padding:0;margin:-1px;overflow:hidden;clip:rect(0,0,0,0);white-space:nowrap;border:0;';
    document.body.insertBefore(h1, document.body.firstChild);
  }

  /* ==============================
     3. ALT TEXT: Fix missing alt on logo and banners
     ============================== */
  var imgs = document.querySelectorAll('img:not([alt]), img[alt=""]');
  imgs.forEach(function(img) {
    var src = (img.src || '').toLowerCase();
    if (src.indexOf('linda') !== -1 && (src.indexOf('logo') !== -1 || src.indexOf('linda_store') !== -1)) {
      img.alt = 'Linda Store - Logo';
    } else if (src.indexOf('banner') !== -1 || src.indexOf('lindastore-banner') !== -1) {
      img.alt = 'Linda Store - Banner Promocional';
    } else if (src.indexOf('colecao_infantil') !== -1 || src.indexOf('infantil') !== -1) {
      img.alt = 'Linda Store - Cole\u00e7\u00e3o Infantil';
    } else if (!img.alt) {
      img.alt = 'Linda Store';
    }
  });

  /* ==============================
     4. JSON-LD: Organization schema (homepage)
     ============================== */
  if (path === '/' || path === '') {
    var orgSchema = {
      "@context": "https://schema.org",
      "@type": "Organization",
      "name": "Linda Store",
      "alternateName": "\u682a\u5f0f\u4f1a\u793eLinda Store",
      "url": "https://lindastore.co.jp",
      "logo": document.querySelector('.tt-logo img') ? document.querySelector('.tt-logo img').src : "https://lindastore.co.jp/cdn/shop/files/Linda_Store_Logo.png",
      "description": "Cal\u00e7ados brasileiros no Jap\u00e3o. Sapatos exclusivos com entrega em todo Jap\u00e3o.",
      "contactPoint": {
        "@type": "ContactPoint",
        "email": "contato@lindastore.co.jp",
        "contactType": "customer service",
        "availableLanguage": ["Portuguese", "Japanese"]
      },
      "sameAs": [
        "https://www.facebook.com/lindastore.co.jp",
        "https://www.instagram.com/lindastore.jp"
      ],
      "address": {
        "@type": "PostalAddress",
        "addressCountry": "JP"
      }
    };
    var script = document.createElement('script');
    script.type = 'application/ld+json';
    script.textContent = JSON.stringify(orgSchema);
    document.head.appendChild(script);
  }

  /* ==============================
     5. JSON-LD: Product schema (product pages)
     ============================== */
  if (path.indexOf('/products/') !== -1 && typeof meta !== 'undefined') {
    try {
      var productMeta = document.querySelector('meta[property="og:title"]');
      var priceMeta = document.querySelector('meta[property="og:price:amount"]');
      var currMeta = document.querySelector('meta[property="og:price:currency"]');
      var imgMeta = document.querySelector('meta[property="og:image"]');
      var descMeta = document.querySelector('meta[property="og:description"]');
      var urlMeta = document.querySelector('meta[property="og:url"]');
      
      if (productMeta && priceMeta) {
        var productSchema = {
          "@context": "https://schema.org",
          "@type": "Product",
          "name": productMeta.content,
          "image": imgMeta ? imgMeta.content : "",
          "description": descMeta ? descMeta.content : "",
          "url": urlMeta ? urlMeta.content : window.location.href,
          "brand": { "@type": "Brand", "name": "Linda Store" },
          "offers": {
            "@type": "Offer",
            "price": priceMeta.content,
            "priceCurrency": currMeta ? currMeta.content : "JPY",
            "availability": "https://schema.org/InStock",
            "seller": { "@type": "Organization", "name": "Linda Store" }
          }
        };
        var pScript = document.createElement('script');
        pScript.type = 'application/ld+json';
        pScript.textContent = JSON.stringify(productSchema);
        document.head.appendChild(pScript);
      }
    } catch(e) {}
  }
})();


// === ESCONDER LINK "CONTATO" DO MENU (aponta pra # e não leva a nada) ===
(function() {
  function hideContatoLink() {
    // Procura links no menu principal que contenham "Contato" e apontem pra "#"
    var menuLinks = document.querySelectorAll('.tt-desctop-menu a, .tt-mobile-menu a, .tt-menu-toggle a, nav a');
    menuLinks.forEach(function(link) {
      var text = (link.textContent || '').trim().toLowerCase();
      var href = (link.getAttribute('href') || '').trim();
      if (text === 'contato' && (href === '#' || href === '' || href === '/pages/contato')) {
        // Esconde o item do menu (li pai ou o próprio link)
        var li = link.closest('li');
        if (li) {
          li.style.display = 'none';
        } else {
          link.style.display = 'none';
        }
      }
    });
  }
  // Rodar quando DOM estiver pronto e após um delay (pra menus dinâmicos)
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', hideContatoLink);
  } else {
    hideContatoLink();
  }
  setTimeout(hideContatoLink, 1500);
  setTimeout(hideContatoLink, 3000);
})();


// === ESCONDER LINK "ÓCULOS" DA SIDEBAR (coleção vazia, não vende mais) ===
(function() {
  function hideOculosLink() {
    var sidebarLinks = document.querySelectorAll('.tt-btn-col-close a, .tt-collapse-content a, .tt-menu-categories a, nav a, .tt-categories-nav a');
    sidebarLinks.forEach(function(link) {
      var href = (link.getAttribute('href') || '').toLowerCase();
      var text = (link.textContent || '').trim().toLowerCase();
      if (href.indexOf('/collections/oculos') !== -1 || text === 'óculos' || text === 'oculos') {
        var li = link.closest('li');
        if (li) {
          li.style.display = 'none';
        } else {
          link.style.display = 'none';
        }
      }
    });
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', hideOculosLink);
  } else {
    hideOculosLink();
  }
  setTimeout(hideOculosLink, 1500);
  setTimeout(hideOculosLink, 3000);
})();


// === ESCONDER LINKS OUTLET/PROMOÇÃO/ÚLTIMOS PARES (coleção não existe, 404) ===
(function() {
  function hideOutletLinks() {
    var allLinks = document.querySelectorAll('a');
    allLinks.forEach(function(link) {
      var href = (link.getAttribute('href') || '').toLowerCase();
      if (href.indexOf('/collections/outlet') !== -1) {
        var li = link.closest('li');
        if (li) {
          li.style.display = 'none';
        } else {
          link.style.display = 'none';
        }
      }
    });
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', hideOutletLinks);
  } else {
    hideOutletLinks();
  }
  setTimeout(hideOutletLinks, 1500);
  setTimeout(hideOutletLinks, 3000);
})();


// === LAZY LOADING NAS IMAGENS (melhora performance) ===
(function() {
  function addLazyLoading() {
    var images = document.querySelectorAll('img:not([loading])');
    var count = 0;
    images.forEach(function(img, index) {
      // Pular as primeiras 4 imagens (above the fold - visíveis sem scroll)
      if (index < 4) return;
      // Pular imagens já carregadas com lazy
      if (img.getAttribute('loading') === 'lazy') return;
      // Adicionar loading="lazy" nativo
      img.setAttribute('loading', 'lazy');
      count++;
    });
    if (count > 0) {
      console.log('[LindaStore] Lazy loading adicionado em ' + count + ' imagens');
    }
  }
  // Rodar quando DOM estiver pronto
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', addLazyLoading);
  } else {
    addLazyLoading();
  }
  // Rodar novamente após conteúdo dinâmico carregar
  setTimeout(addLazyLoading, 2000);
  setTimeout(addLazyLoading, 5000);
})();


// === ESCONDER BOTÃO ANTIGO DE WISHLIST DO TEMA (substituído pelo Wishlist Hero) ===
(function() {
  function hideOldWishlist() {
    // Esconde o botão "Lista de Desejo" no header (classe tt-wishlist)
    var wishlistHeader = document.querySelectorAll('.tt-wishlist');
    wishlistHeader.forEach(function(el) {
      el.style.display = 'none';
    });
    // Esconde links que apontam para /pages/wishlist em menus e rodapé
    var allLinks = document.querySelectorAll('a[href*="/pages/wishlist"]');
    allLinks.forEach(function(link) {
      // Não esconder se for do app Wishlist Hero (tem classe específica)
      if (link.closest('.wishlist-hero') || link.closest('[id*="wishlist-hero"]')) return;
      var li = link.closest('li');
      if (li) {
        li.style.display = 'none';
      } else {
        link.style.display = 'none';
      }
    });
    // === NOVO: Esconde botão antigo de wishlist na PÁGINA DE PRODUTO ===
    // O tema Wokiee usa a classe wlbutton-js e data-type="wishlist"
    var productWishlistBtns = document.querySelectorAll('a.wlbutton-js, a[data-type="wishlist"]');
    productWishlistBtns.forEach(function(btn) {
      // Não esconder se for do Wishlist Hero
      if (btn.closest('.wishlist-hero') || btn.closest('[id*="wishlist-hero"]')) return;
      // Esconder o <li> pai ou o wrapper todo
      var li = btn.closest('li');
      var wrapper = btn.closest('.tt-wrapper');
      if (li) {
        li.style.display = 'none';
      } else if (wrapper) {
        wrapper.style.display = 'none';
      } else {
        btn.style.display = 'none';
      }
    });
    // Esconde também pela classe tt-list-btn que contém botões de wishlist/compare
    var listBtns = document.querySelectorAll('.tt-list-btn');
    listBtns.forEach(function(ul) {
      var items = ul.querySelectorAll('a[data-type="wishlist"]');
      items.forEach(function(a) {
        var parentLi = a.closest('li');
        if (parentLi) parentLi.style.display = 'none';
      });
    });
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', hideOldWishlist);
  } else {
    hideOldWishlist();
  }
  setTimeout(hideOldWishlist, 1500);
  setTimeout(hideOldWishlist, 3000);
})();

// === UPSELL FRETE GRATIS - Sugestao de produtos para completar 7000 ===
(function() {
  var FRETE_MIN_CENTS = 700000;
  
  function fmtYen(cents) {
    return String.fromCharCode(165) + Math.ceil(cents / 100).toLocaleString("ja-JP");
  }
  
  function createBar(cartTotal, cartItems) {
    var old = document.getElementById("frete-gratis-upsell");
    if (old) old.remove();
    
    var falta = FRETE_MIN_CENTS - cartTotal;
    var bar = document.createElement("div");
    bar.id = "frete-gratis-upsell";
    
    if (falta <= 0) {
      bar.innerHTML = "<div style=\"background:linear-gradient(135deg,#CCAC00,#e6c832);color:#fff;padding:15px 20px;border-radius:10px;margin:15px 0;text-align:center;font-size:15px;box-shadow:0 2px 8px rgba(0,0,0,0.1);\">" +
        "<strong>Parabens! Voce tem direito a FRETE GRATIS!</strong></div>";
      insertBar(bar);
      return;
    }
    
    var faltaF = fmtYen(falta);
    var prog = Math.min((cartTotal / FRETE_MIN_CENTS) * 100, 100);
    
    bar.innerHTML = "<div style=\"background:#fff;border:2px solid #CCAC00;border-radius:12px;margin:15px 0;padding:18px 20px;box-shadow:0 2px 10px rgba(204,172,0,0.15);\">" +
      "<div style=\"text-align:center;margin-bottom:12px;\">" +
        "<span style=\"font-size:15px;color:#333;\">Falta apenas <strong style=\"color:#CCAC00;font-size:17px;\">" + faltaF + "</strong> para <strong style=\"color:#CCAC00;\">FRETE GR\u00c1TIS!</strong></span>" +
      "</div>" +
      "<div style=\"background:#f0f0f0;border-radius:20px;height:8px;margin-bottom:14px;overflow:hidden;\">" +
        "<div style=\"background:linear-gradient(90deg,#CCAC00,#e6c832);height:100%;border-radius:20px;width:" + prog + "%;transition:width 0.5s;\"></div>" +
      "</div>" +
      "<div style=\"text-align:center;font-size:13px;color:#666;margin-bottom:10px;\">Adicione mais um item e economize <strong style=\"color:#CCAC00;\">" + String.fromCharCode(165) + "990</strong> no frete!</div>" +
      "<div id=\"frete-upsell-produtos\" style=\"display:flex;gap:12px;justify-content:center;flex-wrap:wrap;margin-top:10px;\"></div>" +
    "</div>";
    
    insertBar(bar);
    fetchSuggestions(falta, cartItems);
  }
  
  function insertBar(bar) {
        var checkout = document.querySelector(".tt-shopcart-btn");
        if (checkout) { checkout.parentNode.insertBefore(bar, checkout); return; }
        var subtotalTable = document.querySelector("table.tt-shopcart-table-02");
        if (subtotalTable) { subtotalTable.parentNode.insertBefore(bar, subtotalTable); return; }
        var cartBtns = document.querySelectorAll(".btn-lg");
        for (var i = 0; i < cartBtns.length; i++) {
          if (cartBtns[i].textContent.indexOf("Continuar") !== -1 || cartBtns[i].textContent.indexOf("Checkout") !== -1) {
            var wrapper = cartBtns[i].closest("div");
            if (wrapper) { wrapper.parentNode.insertBefore(bar, wrapper); return; }
          }
        }
        var h = document.querySelector("h1");
        if (h) { h.parentNode.insertBefore(bar, h.nextSibling); return; }
        var main = document.querySelector("main") || document.querySelector(".container");
        if (main) main.insertBefore(bar, main.firstChild);
      }
  
  function fetchSuggestions(faltaCents, cartItems) {
        var cartPids = cartItems.map(function(it) { return it.product_id; });
        var cats = [
          { handle: "semijoias-brinco", grupo: "semijoias" },
          { handle: "semijoias-colar", grupo: "semijoias" },
          { handle: "semijoias-conjunto", grupo: "semijoias" },
          { handle: "semijoias-pulseira", grupo: "semijoias" },
          { handle: "sandalias", grupo: "calcados" },
          { handle: "rasteiras", grupo: "calcados" },
          { handle: "sapatilhas", grupo: "calcados" },
          { handle: "scarpins", grupo: "calcados" },
          { handle: "bolsas", grupo: "bolsas" },
          { handle: "infantil", grupo: "infantil" },
          { handle: "botas", grupo: "botas" }
        ];
        var promises = cats.map(function(cat) {
          return fetch("/collections/" + cat.handle + "/products.json?limit=30")
            .then(function(r) { return r.json(); })
            .then(function(data) { return { grupo: cat.grupo, products: data.products || [] }; })
            .catch(function() { return { grupo: cat.grupo, products: [] }; });
        });
        Promise.all(promises).then(function(results) {
          var porGrupo = {};
          for (var r = 0; r < results.length; r++) {
            var grupo = results[r].grupo;
            var prods = results[r].products;
            if (!porGrupo[grupo]) porGrupo[grupo] = [];
            for (var i = 0; i < prods.length; i++) {
              var p = prods[i];
              if (cartPids.indexOf(p.id) !== -1) continue;
              if (!p.variants || !p.variants[0] || !p.variants[0].available) continue;
              var preco = parseFloat(p.variants[0].price) * 100;
              if (preco < 20000) continue;
              var jaTem = false;
              for (var x = 0; x < porGrupo[grupo].length; x++) {
                if (porGrupo[grupo][x].id === p.id) { jaTem = true; break; }
              }
              if (!jaTem) {
                porGrupo[grupo].push({ id: p.id, title: p.title, price: preco, priceF: fmtYen(preco), url: "/products/" + p.handle, img: (p.images && p.images[0]) ? p.images[0].src : "", completaFrete: preco >= faltaCents });
              }
            }
          }
          var grupos = Object.keys(porGrupo);
          for (var g = 0; g < grupos.length; g++) {
            porGrupo[grupos[g]].sort(function(a, b) { return a.price - b.price; });
          }
          var ordem = ["semijoias", "calcados", "bolsas", "infantil", "botas"];
          var mostrar = [];
          for (var o = 0; o < ordem.length && mostrar.length < 3; o++) {
            var grp = ordem[o];
            if (porGrupo[grp] && porGrupo[grp].length > 0) {
              mostrar.push(porGrupo[grp][0]);
            }
          }
          var box = document.getElementById("frete-upsell-produtos");
          if (!box || mostrar.length === 0) return;
          var html = "";
          for (var j = 0; j < mostrar.length; j++) {
            var s = mostrar[j];
            var badge = s.completaFrete ? "<span style=\"position:absolute;top:-6px;right:-6px;background:#CCAC00;color:#fff;font-size:9px;padding:2px 6px;border-radius:10px;font-weight:bold;\">FRETE GR" + String.fromCharCode(193) + "TIS</span>" : "";
            var imgTag = s.img ? "<img src=\"" + s.img + "\" style=\"width:70px;height:70px;object-fit:cover;border-radius:6px;\" alt=\"\">" : "";
            html += "<a href=\"" + s.url + "\" style=\"position:relative;display:flex;flex-direction:column;align-items:center;text-decoration:none;background:#fafafa;border:1px solid #eee;border-radius:8px;padding:10px;width:140px;transition:border-color 0.2s;\">" + badge + imgTag +
              "<span style=\"font-size:12px;color:#333;text-align:center;margin-top:6px;line-height:1.3;max-height:32px;overflow:hidden;\">" + s.title + "</span>" +
              "<span style=\"font-size:13px;color:#CCAC00;font-weight:bold;margin-top:4px;\">" + s.priceF + "</span></a>";
          }
          box.innerHTML = html;
        }).catch(function(e) { console.log("Upsell frete erro:", e); });
      }
  
  function checkCart() {
    fetch("/cart.js")
      .then(function(r) { return r.json(); })
      .then(function(cart) {
        if (cart.item_count === 0) return;
        createBar(cart.total_price, cart.items);
      })
      .catch(function(e) { console.log("Upsell cart erro:", e); });
  }
  
  function init() {
    if (window.location.pathname.indexOf("/cart") !== -1) {
      checkCart();
    }
  }
  
  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", init);
  } else {
    init();
  }
})();

// === MINI-CART: Redireciona Continuar para /cart (upsell frete gratis) ===
(function() {
  function fixMiniCartBtn() {
    var cartLayout = document.querySelector(".tt-cart-layout");
    if (!cartLayout) return;
    var links = cartLayout.querySelectorAll("a.btn");
    for (var i = 0; i < links.length; i++) {
      var href = links[i].getAttribute("href") || "";
      if (href.indexOf("/checkout") !== -1) {
        links[i].setAttribute("href", "/cart");
        links[i].setAttribute("data-original-href", href);
      }
    }
  }
  fixMiniCartBtn();
  var observer = new MutationObserver(function() { fixMiniCartBtn(); });
  var cartParent = document.querySelector(".tt-desctop-parent-cart") || document.querySelector(".tt-mobile-parent-cart");
  if (cartParent) {
    observer.observe(cartParent, { childList: true, subtree: true });
  }
  setInterval(fixMiniCartBtn, 2000);
})();

// === CENTRALIZAR CALENDARIO E HORARIO DE ENTREGA (Buunto) ===
(function() {
  function centerBuunto() {
    if (window.location.pathname.indexOf("/cart") === -1) return;
    var picker = document.querySelector(".buunto-date-picker.buunto-cart-page");
    if (picker && !picker.dataset.centered) {
      picker.style.cssText = "display:flex;flex-direction:column;align-items:center;width:100%;margin:20px auto;";
      picker.dataset.centered = "1";
    }
    var timePicker = document.querySelector(".buunto-time-slot-picker");
    if (timePicker && !timePicker.dataset.centered) {
      timePicker.style.cssText = "display:flex;flex-direction:column;align-items:center;width:100%;margin:10px auto;";
      timePicker.dataset.centered = "1";
    }
    var dateField = document.querySelector(".buunto-date-field");
    if (dateField && !dateField.dataset.centered) {
      dateField.style.cssText = "display:flex;flex-direction:column;align-items:center;";
      dateField.dataset.centered = "1";
    }
  }
  centerBuunto();
  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", function() { setTimeout(centerBuunto, 1000); });
  } else {
    setTimeout(centerBuunto, 1000);
    setTimeout(centerBuunto, 3000);
  }
})();



// ======= LOCALE TRANSLATION OVERLAY (JA) =======
(function() {
  if (window.location.pathname.indexOf("/ja/") !== 0) return;
  var _fBusy = false, _fTmr = null;

  function translateFrete() {
    if (_fBusy) return;
    var bar = document.getElementById("frete-gratis-upsell");
    if (!bar) return;
    var h = bar.innerHTML;
    if (h.indexOf("FRETE") < 0 && h.indexOf("Parabens") < 0 && h.indexOf("Falta") < 0 && h.indexOf("Adicione") < 0 && h.indexOf("frete") < 0) return;
    _fBusy = true;
    try {
      h = h.replace(/Parabens!\s*Voce tem direito a FRETE GRATIS!/g, "\u304A\u3081\u3067\u3068\u3046\u3054\u3056\u3044\u307E\u3059\uFF01\u9001\u6599\u7121\u6599\u3067\u3059\uFF01");
      h = h.replace(/Falta apenas/g, "\u9001\u6599\u7121\u6599\u307E\u3067\u3042\u3068");
      h = h.replace(/para\s*<strong[^>]*>FRETE GR.TIS!<\/strong>/g, "");
      h = h.replace(/Adicione mais um item e economize/g, "\u3042\u3068\uFF11\u70B9\u8FFD\u52A0\u3067\u9001\u6599");
      h = h.replace(/no frete!/g, "\u304A\u5F97\uFF01");
      h = h.replace(/FRETE GR[^<]{0,5}TIS/g, "\u9001\u6599\u7121\u6599");
      bar.innerHTML = h;
    } finally { setTimeout(function(){ _fBusy = false; }, 500); }
  }

  var obs = new MutationObserver(function(){ clearTimeout(_fTmr); _fTmr = setTimeout(translateFrete, 300); });
  function startObs() {
    var sec = document.getElementById("shopify-section-cart-template");
    if (sec) { obs.observe(sec, { childList: true, subtree: true }); }
    else { setTimeout(startObs, 1000); }
  }
  startObs();
  setTimeout(translateFrete, 1500);
  setTimeout(translateFrete, 3000);
  setTimeout(translateFrete, 5000);
  setTimeout(translateFrete, 8000);
})();
